export interface CalculatorItem {
  name: string;
  englishName: string;
  path: string;
  isImplemented?: boolean;
  siloGroup?: 'jahr' | 'bundesland' | 'spezial';
}

export interface CategoryGroup {
  id: string;
  title: string;
  englishTitle: string;
  count: number;
  calculators: CalculatorItem[];
}

export const CATEGORIES_DATA: CategoryGroup[] = [
  {
    id: "arbeit-soziales",
    title: "Arbeit & Soziales",
    englishTitle: "Arbeit und Soziales",
    count: 26,
    calculators: [
      { name: "Abfindungsrechner", englishName: "Severance calculator", path: "#/abfindungsrechner", isImplemented: true },
      { name: "Arbeitslosengeld-Rechner", englishName: "Unemployment benefit calculator", path: "#/arbeitslosengeld-rechner", isImplemented: true },
      { name: "BAföG-Rechner", englishName: "BAföG calculator", path: "#/bafoeg-rechner", isImplemented: true },
      { name: "Bürgergeld-Rechner", englishName: "Citizen's income calculator", path: "#/buergergeld-rechner", isImplemented: true },
      { name: "Elterngeldrechner", englishName: "Parental allowance calculator", path: "#/elterngeld-rechner", isImplemented: true },
      { name: "Elternzeitrechner", englishName: "Parental leave calculator", path: "#/elternzeitrechner", isImplemented: true },
      { name: "Wohngeldrechner", englishName: "Housing benefit calculator", path: "#/wohngeldrechner", isImplemented: true },
      { name: "Gehaltserhöhungs-Rechner", englishName: "Salary increase calculator", path: "#/gehaltserhoehung-rechner" },
      { name: "Grundsicherungsrechner", englishName: "Basic income support calculator", path: "#/grundsicherungsrechner" },
      { name: "Grundeinkommens-Rechner", englishName: "Basic income calculator", path: "#/grundeinkommens-rechner" },
      { name: "Kindergeld-Rechner", englishName: "Child benefit calculator", path: "#/kindergeld-rechner" },
      { name: "Kinderzuschlag-Rechner", englishName: "Child supplement calculator", path: "#/kinderzuschlag-rechner" },
      { name: "Kurzarbeitergeld-Rechner", englishName: "Short-time work allowance calculator", path: "#/kurzarbeitergeld-rechner" },
      { name: "Kurzarbeitergeld für Arbeitgeber", englishName: "Short-time work allowance for employers", path: "#/kurzarbeitergeld-arbeitgeber" },
      { name: "Minijob-Rechner", englishName: "Minijob calculator", path: "#/minijob" },
      { name: "Mindestlohnrechner", englishName: "Minimum wage calculator", path: "#/mindestlohnrechner" },
      { name: "Midi-Job-Rechner", englishName: "Midi-job calculator", path: "#/minijob" },
      { name: "Mutterschaftsgeld-Rechner", englishName: "Maternity allowance calculator", path: "#/mutterschaftsgeld-rechner" },
      { name: "Mutterschutz-Rechner", englishName: "Maternity leave calculator", path: "#/mutterschutz-rechner" },
      { name: "Pendlerpauschale", englishName: "Commuter allowance calculator", path: "#/pendlerpauschale" },
      { name: "Stundenlohnrechner", englishName: "Hourly wage calculator", path: "#/stundenlohnrechner" },
      { name: "Teilzeitrechner", englishName: "Part-time calculator", path: "#/teilzeitrechner" },
      { name: "Übergangsgeld", englishName: "Transitional allowance calculator", path: "#/uebergangsgeld" },
      { name: "Urlaubsanspruch Elternzeit", englishName: "Vacation entitlement Parental leave", path: "#/urlaubsanspruch-elternzeit" },
      { name: "Urlaubsanspruch-Rechner", englishName: "Vacation entitlement calculator", path: "#/urlaubsanspruch-rechner" }
    ]
  },
  {
    id: "energie",
    title: "Energie",
    englishTitle: "Energie & Haushalt",
    count: 6,
    calculators: [
      { name: "Gasverbrauchsrechner", englishName: "Calculate gas consumption", path: "#/gasverbrauch", isImplemented: true },
      { name: "LED-Watt-Umrechner", englishName: "LED watt calculator", path: "#/led-watt", isImplemented: true },
      { name: "Stromkostenrechner", englishName: "Electricity cost calculator", path: "#/stromkosten", isImplemented: true },
      { name: "Stromverbrauchsrechner", englishName: "Calculate electricity consumption", path: "#/stromverbrauch", isImplemented: true },
      { name: "Volt-Watt-Ampere-Converter", englishName: "Volt Watt Amp Converter", path: "#/volt-watt-amp", isImplemented: true },
      { name: "Wärmepumpen-Rechner", englishName: "Heat pump calculator", path: "#/waermepumpe", isImplemented: true }
    ]
  },
  {
    id: "feiertage-2027",
    title: "Feiertage 2027 & 2026",
    englishTitle: "Feiertage & Brückentage",
    count: 19,
    calculators: [
      // 1. Feiertage nach Jahren
      { name: "Feiertage 2027", englishName: "Public Holidays 2027 Germany", path: "#/feiertage-2027", isImplemented: true, siloGroup: "jahr" },
      { name: "Feiertage 2026", englishName: "Public Holidays 2026 Germany", path: "#/feiertage-2026", isImplemented: true, siloGroup: "jahr" },
      { name: "Feiertage 2025", englishName: "Public Holidays 2025 Germany", path: "#/feiertage-2025", isImplemented: true, siloGroup: "jahr" },
      { name: "Feiertage in Deutschland", englishName: "Public Holidays in Germany overview", path: "#/feiertage-in-deutschland", isImplemented: true, siloGroup: "jahr" },
      { name: "Feiertage Gesamtübersicht", englishName: "Public Holidays Germany", path: "#/feiertage", isImplemented: true, siloGroup: "jahr" },

      // 2. Feiertage nach Bundesland (2026 / 2025)
      { name: "Feiertage NRW 2026", englishName: "Public Holidays North Rhine-Westphalia 2026", path: "#/feiertage-nrw-2026", isImplemented: true, siloGroup: "bundesland" },
      { name: "Feiertage Bayern 2026", englishName: "Public Holidays Bavaria 2026", path: "#/feiertage-bayern-2026", isImplemented: true, siloGroup: "bundesland" },
      { name: "Feiertage Baden-Württemberg (BW) 2026", englishName: "Public Holidays Baden-Württemberg 2026", path: "#/feiertage-bw-2026", isImplemented: true, siloGroup: "bundesland" },
      { name: "Feiertage Hessen 2026", englishName: "Public Holidays Hesse 2026", path: "#/feiertage-hessen-2026", isImplemented: true, siloGroup: "bundesland" },
      { name: "Feiertage Niedersachsen 2026", englishName: "Public Holidays Lower Saxony 2026", path: "#/feiertage-niedersachsen-2026", isImplemented: true, siloGroup: "bundesland" },
      { name: "Feiertage Berlin 2026", englishName: "Public Holidays Berlin 2026", path: "#/feiertage-berlin-2026", isImplemented: true, siloGroup: "bundesland" },
      { name: "Feiertage Sachsen 2026", englishName: "Public Holidays Saxony 2026", path: "#/feiertage-sachsen-2026", isImplemented: true, siloGroup: "bundesland" },
      { name: "Feiertage RLP 2026 (Rheinland-Pfalz)", englishName: "Public Holidays Rhineland-Palatinate 2026", path: "#/feiertage-rlp-2026", isImplemented: true, siloGroup: "bundesland" },
      { name: "Feiertage Hamburg 2026", englishName: "Public Holidays Hamburg 2026", path: "#/feiertage-hamburg-2026", isImplemented: true, siloGroup: "bundesland" },
      { name: "Feiertage NRW 2025", englishName: "Public Holidays North Rhine-Westphalia 2025", path: "#/feiertage-nrw-2025", isImplemented: true, siloGroup: "bundesland" },
      { name: "Feiertage Bayern 2025", englishName: "Public Holidays Bavaria 2025", path: "#/feiertage-bayern-2025", isImplemented: true, siloGroup: "bundesland" },
      { name: "Feiertage Sachsen 2025", englishName: "Public Holidays Saxony 2025", path: "#/feiertage-sachsen-2025", isImplemented: true, siloGroup: "bundesland" },

      // 3. Spezial-Planer
      { name: "Brückentage-Planer 2026/2027", englishName: "Bridge Days Planner", path: "#/brueckentage-planer", isImplemented: true, siloGroup: "spezial" },
      { name: "Feiertage Mai 2026", englishName: "Public Holidays May 2026", path: "#/feiertage-mai-2026", isImplemented: true, siloGroup: "spezial" }
    ]
  },
  {
    id: "geldanlage-sparen",
    title: "Geldanlage & Sparen",
    englishTitle: "Geldanlage & Sparen",
    count: 13,
    calculators: [
      { name: "Bankrecherche & Bankensuche", englishName: "Bank research & directory", path: "/bankrecherche", isImplemented: true },
      { name: "Bankleitzahlensuche", englishName: "Bank search by bank code", path: "/blz-suche", isImplemented: true },
      { name: "Bankverbindung prüfen", englishName: "Check bank details", path: "/bankverbindung-pruefen", isImplemented: true },
      { name: "Währungsrechner", englishName: "Currency converter", path: "/waehrungsrechner", isImplemented: true },
      { name: "Entnahmeplanrechner (ETF & Rente)", englishName: "Withdrawal plan calculator", path: "/entnahmeplanrechner", isImplemented: true },
      { name: "ETF-Sparplanrechner", englishName: "ETF savings plan calculator", path: "/etf-sparplanrechner", isImplemented: true },
      { name: "IBAN-Rechner & Generator", englishName: "IBAN & BIC calculator", path: "/iban-rechner", isImplemented: true },
      { name: "Inflationsrechner", englishName: "Inflation calculator", path: "#/inflation-rechner" },
      { name: "Marge berechnen", englishName: "Calculate margin", path: "#/marge" },
      { name: "Skontorechner", englishName: "Discount calculator", path: "#/skontorechner" },
      { name: "Sparrechner", englishName: "Savings calculator", path: "#/sparrechner" },
      { name: "Zinseszinsrechner", englishName: "Compound interest calculator", path: "#/sparrechner" },
      { name: "Zinsrechner", englishName: "Interest calculator", path: "#/sparrechner" }
    ]
  },
  {
    id: "gesundheit",
    title: "Gesundheit",
    englishTitle: "Gesundheit & Vorsorge",
    count: 13,
    calculators: [
      { name: "BMI-Rechner", englishName: "BMI calculator", path: "/bmi-rechner", isImplemented: true },
      { name: "BMI für Kinder", englishName: "BMI calculator for children", path: "/bmi-rechner-kinder", isImplemented: true },
      { name: "Eisprungrechner (Ovulationsrechner)", englishName: "Ovulation calculator", path: "/eisprungrechner", isImplemented: true },
      { name: "Freiwillige Krankenversicherung", englishName: "Voluntary health insurance", path: "#/krankenversicherung-freiwillig" },
      { name: "Geburtsterminrechner (ET Rechner)", englishName: "Due date calculator", path: "/et-rechner", isImplemented: true },
      { name: "Zahnersatz Härtefallberechnung", englishName: "Hardship calculator for dental prosthetics", path: "#/zahnersatz-haertefall" },
      { name: "Kalorienbedarf-Rechner", englishName: "Calorie requirement calculator", path: "#/kalorienbedarf" },
      { name: "Krankengeldrechner", englishName: "Sickness benefit calculator", path: "#/krankengeld" },
      { name: "Krankenkassenbeitrag", englishName: "Health insurance contribution", path: "#/krankenkassenbeitrag" },
      { name: "Krankheitskosten absetzen", englishName: "Deducting medical expenses", path: "#/krankheitskosten" },
      { name: "Schwangerschaftswochen-Rechner (SSW Rechner)", englishName: "SSW calculator", path: "/ssw-rechner", isImplemented: true },
      { name: "Schmerzensgeldrechner", englishName: "Injury compensation calculator", path: "#/schmerzensgeld" },
      { name: "Zahnersatz-Kostenrechner", englishName: "Dental prosthesis cost calculator", path: "#/zahnersatz-kosten" }
    ]
  },
  {
    id: "kredit-finanzierung",
    title: "Kredit & Finanzierung",
    englishTitle: "Kredit & Finanzierung",
    count: 12,
    calculators: [
      { name: "Annuitätenrechner", englishName: "Annuity calculator", path: "#/kreditrechner" },
      { name: "Autofinanzierung-Rechner", englishName: "Car loan calculator", path: "#/autofinanzierung" },
      { name: "Restwert-Rechner (Auto-Wertverlust)", englishName: "Car residual value calculator", path: "/restwert-rechner", isImplemented: true },
      { name: "Baufinanzierungsrechner", englishName: "Home loan calculator", path: "#/kreditrechner" },
      { name: "Ratenkredit-Rechner", englishName: "Loan calculator", path: "#/kreditrechner" },
      { name: "Hypothekenrechner (Tilgung)", englishName: "Mortgage calculator", path: "#/kreditrechner" },
      { name: "Tilgungsrechner", englishName: "Amortization calculator", path: "#/kreditrechner" },
      { name: "Umschuldungsrechner", englishName: "Debt restructuring calculator", path: "#/umschuldung" },
      { name: "Leasingrechner", englishName: "Leasing calculator", path: "#/leasing" },
      { name: "PayPal-Gebührenrechner", englishName: "PayPal Fee Calculator", path: "#/paypal-gebuehren" }
    ]
  },
  {
    id: "mathematik",
    title: "Mathematik",
    englishTitle: "Mathematik",
    count: 15,
    calculators: [
      { name: "Bruchrechner", englishName: "Fraction calculator", path: "#/bruchrechner" },
      { name: "Dreisatz-Rechner", englishName: "Rule of three calculator", path: "#/dreisatz" },
      { name: "Geschwindigkeit berechnen", englishName: "Calculate speeds", path: "#/geschwindigkeit" },
      { name: "Kreis berechnen", englishName: "Calculate circle", path: "#/kreis-berechnen" },
      { name: "Kubikmeter-Rechner", englishName: "Cubic meter calculator", path: "#/kubikmeter" },
      { name: "Maßstabrechner", englishName: "Scale calculator", path: "#/massstab" },
      { name: "Durchschnittsrechner", englishName: "Average calculator", path: "#/durchschnitt" },
      { name: "Prozentrechner", englishName: "Percent calculator", path: "#/prozentrechner" },
      { name: "Römische Zahlen", englishName: "Roman numerals", path: "#/roemische-zahlen" },
      { name: "Steigung & Gefälle", englishName: "Slope and gradient", path: "#/steigung" },
      { name: "Online-Rechner", englishName: "online calculator", path: "#/online-rechner" },
      { name: "Volumen berechnen", englishName: "Calculate volume", path: "#/volumen" },
      { name: "Zufallsgenerator", englishName: "Number generator", path: "#/zufallsgenerator" },
      { name: "Zylinder berechnen", englishName: "Calculate cylinder", path: "#/zylinder" }
    ]
  },
  {
    id: "pflege",
    title: "Pflege",
    englishTitle: "Pflege & Betreuung",
    count: 4,
    calculators: [
      { name: "Pflegegeldrechner", englishName: "Care allowance calculator", path: "#/pflegegeld" },
      { name: "Pflegegradrechner", englishName: "Care level calculator", path: "#/pflegegrad" },
      { name: "Pflegeheim-Eigenanteil", englishName: "Nursing home co-payment", path: "#/pflegeheim-eigenanteil" }
    ]
  },
  {
    id: "recht",
    title: "Recht",
    englishTitle: "Recht",
    count: 14,
    calculators: [
      { name: "Bußgeldrechner", englishName: "Speed limit fine calculator", path: "#/bussgeldrechner" },
      { name: "Ehegattenunterhalt", englishName: "Spousal maintenance calculator", path: "#/ehegattenunterhalt" },
      { name: "Erbscheinkosten", englishName: "Probate Certificate Cost Calculator", path: "#/erbscheinkosten" },
      { name: "Gesetzliche Erbfolge Rechner", englishName: "Statutory inheritance calculator without will", path: "/erbfolge-rechner", isImplemented: true },
      { name: "Fristenrechner", englishName: "Deadline calculator", path: "#/fristenrechner" },
      { name: "Gerichtskostenrechner", englishName: "Court cost calculator", path: "#/gerichtskostenrechner" },
      { name: "Kindesunterhalt (Düsseldorfer Tabelle)", englishName: "Child support calculator", path: "#/kindesunterhalt" },
      { name: "Pfändungsrechner 2026", englishName: "Garnishment calculator 2026", path: "#/pfaendungsrechner" },
      { name: "Promillerechner", englishName: "Blood alcohol calculator", path: "#/promillerechner" },
      { name: "Prozesskostenrechner", englishName: "Process cost calculator", path: "#/prozesskostenrechner" },
      { name: "RVG-Rechner", englishName: "RVG calculator", path: "#/rvg-rechner" },
      { name: "Scheidungsvereinbarung Kosten", englishName: "Divorce settlement agreement calculator", path: "#/scheidungsvereinbarung" },
      { name: "Scheidungskosten", englishName: "Divorce cost calculator", path: "#/scheidungskosten" },
      { name: "Urlaubsgeld-Rechner", englishName: "Holiday pay calculator", path: "#/urlaubsgeld-rechner" }
    ]
  },
  {
    id: "rente",
    title: "Rente",
    englishTitle: "Rente",
    count: 9,
    calculators: [
      { name: "Aktiver Rentenrechner", englishName: "Active pension calculator", path: "#/rentenschätzer" },
      { name: "Rentenbezugsrechner", englishName: "Retirement savings account calculator", path: "#/rentenbezugsrechner" },
      { name: "Erwerbsminderungsrente", englishName: "Disability pension calculator", path: "#/erwerbsminderungsrente" },
      { name: "Rentensteuer-Rechner", englishName: "Pension tax calculator", path: "#/rentensteuer" },
      { name: "Rentenbeginnrechner", englishName: "Retirement start calculator", path: "#/rentenbeginn" },
      { name: "Rentenlücke berechnen", englishName: "Pension gap calculator", path: "#/rentenluecke" },
      { name: "Rentenschätzer", englishName: "Pension calculator", path: "#/rentenschaetzer" },
      { name: "Waisenrente berechnen", englishName: "Orphan's pension calculation", path: "#/waisenrente" },
      { name: "Witwenrente-Rechner", englishName: "Widow's pension calculator", path: "#/witwenrente" }
    ]
  },
  {
    id: "schule-noten",
    title: "Schule & Noten",
    englishTitle: "Schule & Noten",
    count: 6,
    calculators: [
      { name: "Abitur-Notenrechner", englishName: "Abitur grade calculator", path: "#/abitur-rechner" },
      { name: "IHK-Notenrechner", englishName: "Chamber of Industry and Commerce grade calculator", path: "#/ihk-noten" },
      { name: "Notendurchschnitt berechnen", englishName: "Calculate grade point average", path: "#/notendurchschnitt" },
      { name: "Notenpunkte in Noten", englishName: "Grade points in grades", path: "#/notenpunkte" },
      { name: "Schulnotenrechner", englishName: "Grade calculator", path: "#/schulnoten" },
      { name: "Notenschlüsselrechner (IHK)", englishName: "Music key calculator with base and bend", path: "#/notenschluessel" }
    ]
  },
  {
    id: "selbsttests",
    title: "Selbsttests",
    englishTitle: "Selbsttests",
    count: 2,
    calculators: [
      { name: "Burnout-Selbsttest", englishName: "Burnout self-test", path: "#/burnout-test" },
      { name: "Depressions-Selbsttest", englishName: "Depression self-test", path: "#/depression-test" }
    ]
  },
  {
    id: "steuerrechner",
    title: "Steuerrechner",
    englishTitle: "Steuerrechner",
    count: 22,
    calculators: [
      { name: "Abgeltungsteuerrechner", englishName: "Withholding tax calculator", path: "#/abgeltungsteuerrechner", isImplemented: true },
      { name: "Außergewöhnliche Belastungen", englishName: "Exceptional burdens", path: "#/aussergewoehnliche-belastungen", isImplemented: true },
      { name: "Brutto-Netto-Rechner", englishName: "Gross-to-net calculator", path: "#/brutto-netto", isImplemented: true },
      { name: "Bruttorechner", englishName: "Gross Calculator (Net to Gross)", path: "#/bruttorechner", isImplemented: true },
      { name: "Einkommensteuer-Rechner", englishName: "Income tax calculator", path: "#/einkommensteuer", isImplemented: true },
      { name: "Erbschaftsteuer-Rechner", englishName: "Inheritance tax calculator", path: "#/erbschaftsteuer-rechner", isImplemented: true },
      { name: "Firmenwagenrechner", englishName: "Company car calculator", path: "#/firmenwagenrechner" },
      { name: "Gewerbesteuerrechner", englishName: "Business tax calculator", path: "#/gewerbesteuerrechner" },
      { name: "Kapitalertragsteuer-Rechner", englishName: "Capital gains tax calculator", path: "#/abgeltungsteuerrechner", isImplemented: true },
      { name: "Kfz-Steuer-Rechner", englishName: "Vehicle tax calculator", path: "#/kfz-steuer-rechner" },
      { name: "Kirchensteuerrechner", englishName: "Church tax calculator", path: "#/kirchensteuerrechner" },
      { name: "Lohnsteuer-Rechner", englishName: "Wage tax calculator", path: "#/lohnsteuerrechner", isImplemented: true },
      { name: "Nettopreis-Rechner", englishName: "Net price calculator", path: "#/nettopreis-rechner", isImplemented: true },
      { name: "Schenkungsteuerrechner", englishName: "Gift tax calculator", path: "#/schenkungsteuerrechner" },
      { name: "Solidaritätszuschlag-Rechner", englishName: "Solidarity calculator", path: "#/solidaritaetszuschlag-rechner" },
      { name: "Steuerberater für Unternehmen", englishName: "Tax advisor fees for companies", path: "#/steuerberater-unternehmen" },
      { name: "Steuerberatergebühren-Rechner", englishName: "Tax advisor fee calculator", path: "#/steuerberatergebuehren" },
      { name: "Steuerklassenrechner", englishName: "Tax class calculator", path: "#/steuerklassenrechner" },
      { name: "Steuerrechner (Steuer berechnen)", englishName: "Tax calculator (Calculate Tax)", path: "#/steuer-berechnen", isImplemented: true },
      { name: "Umsatzsteuerrechner", englishName: "VAT calculator", path: "#/umsatzsteuerrechner" },
      { name: "Vorauszahlungsrechner", englishName: "Advance payment calculator", path: "#/vorauszahlungsrechner" },
      { name: "Zumutbare Belastung", englishName: "Calculate reasonable burden", path: "#/zumutbare-belastung" }
    ]
  },
  {
    id: "umrechner",
    title: "Umrechner",
    englishTitle: "Umrechner & Maße",
    count: 8,
    calculators: [
      { name: "Flächenumrechner", englishName: "Area converter", path: "#/flaechenumrechner" },
      { name: "Geschwindigkeitsumrechner", englishName: "Speed converter", path: "#/geschwindigkeitsumrechner" },
      { name: "Gewichtsumrechner", englishName: "Weight converter", path: "#/gewichtsumrechner" },
      { name: "Längenumrechner", englishName: "Length converter", path: "#/laengenumrechner", isImplemented: true },
      { name: "ET Rechner Felgen (Einpresstiefe)", englishName: "Wheel offset calculator", path: "#/et-rechner-felgen", isImplemented: true },
      { name: "Schuhgrößenumrechner", englishName: "Convert shoe sizes", path: "#/schuhgroessen" },
      { name: "Volumenumrechner", englishName: "Volume converter", path: "#/volumenumrechner" },
      { name: "Zeitumrechner", englishName: "Time converter", path: "#/zeitumrechner" }
    ]
  },
  {
    id: "wohnen",
    title: "Wohnen",
    englishTitle: "Wohnen & Immobilien",
    count: 3,
    calculators: [
      { name: "Grunderwerbsteuer-Rechner", englishName: "Real estate transfer tax calculator", path: "#/grunderwerbsteuer" },
      { name: "Kaufnebenkostenrechner", englishName: "Home purchase additional costs calculator", path: "#/kaufnebenkostenrechner" },
      { name: "Quadratmeter-Rechner", englishName: "Calculate square meters", path: "#/quadratmeter-rechner" }
    ]
  },
  {
    id: "zeit-datum",
    title: "Zeit & Datum",
    englishTitle: "Zeit & Datum",
    count: 13,
    calculators: [
      { name: "Altersrechner", englishName: "Age calculator", path: "#/altersrechner", isImplemented: true },
      { name: "Arbeitstage-Rechner", englishName: "Working day calculator", path: "#/arbeitstage-rechner", isImplemented: true },
      { name: "Arbeitszeitrechner", englishName: "Work time calculator", path: "#/arbeitszeitrechner", isImplemented: true },
      { name: "Zeitrechner", englishName: "Time calculator", path: "#/zeitrechner", isImplemented: true },
      { name: "Datumsrechner", englishName: "Date calculator", path: "#/datumsrechner", isImplemented: true },
      { name: "Ferien in Deutschland", englishName: "Holidays in Germany", path: "#/ferien" },
      { name: "Kalender", englishName: "Calendar", path: "#/kalender" },
      { name: "Kalenderwochen", englishName: "Calendar weeks", path: "#/kalenderwochen" },
      { name: "Mondkalender", englishName: "Moon calendar", path: "#/mondkalender" },
      { name: "Pace-Rechner", englishName: "Pace calculator", path: "#/pace-rechner" },
      { name: "Sonnenaufgang / Sonnenuntergang", englishName: "Sunrise Sunset", path: "#/sonnenaufgang-untergang" },
      { name: "Tagesrechner", englishName: "Daily calculator", path: "#/tagesrechner" },
      { name: "Vollmond-Kalender", englishName: "Full moon calender", path: "#/vollmond" }
    ]
  }
];

export interface GuidelineItem {
  title: string;
  category: string;
  imageAlt: string;
}

export const RATGEBER_HIGHLIGHTS: GuidelineItem[] = [
  { title: "Inflationsrate in Deutschland 2026", category: "Wirtschaft & Finanzen", imageAlt: "Inflation rate Germany" },
  { title: "Stromverbrauch eines Fernsehers im Jahr", category: "Energie & Haushalt", imageAlt: "TV power consumption" },
  { title: "Stromverbrauch eines K\u00FChlschranks ermitteln", category: "Energie & Haushalt", imageAlt: "Refrigerator electricity consumption" },
  { title: "W\u00E4sche waschen: Strom- und Wasserverbrauch", category: "Energie & Haushalt", imageAlt: "Washing machine electricity consumption" },
  { title: "Br\u00FCche addieren: Formeln & einfache Erkl\u00E4rung", category: "Mathematik & Schule", imageAlt: "Addition of fractions" },
  { title: "Fl\u00E4che eines Dreiecks einfach berechnen", category: "Mathematik & Schule", imageAlt: "Area of a triangle" },
  { title: "Fernseher Gr\u00F6lentabelle: 55 Zoll in cm", category: "Technik", imageAlt: "TV size 55 inches in cm" },
  { title: "D\u00FCsseldorfer Tabelle 2026: S\u00E4tze und Richtlinien", category: "Recht & Familie", imageAlt: "D\u00FCsseldorf Table 2026" },
  { title: "Euro TL Kurs: Euro zu T\u00FCrkischer Lira umrechnen", category: "Geldanlage", imageAlt: "Euro TL | Euro to Lira conversion" },
  { title: "Zoll in cm umrechnen (inch in cm Tabelle)", category: "Umrechnung", imageAlt: "inch in cm / Zoll in cm" },
  { title: "Dollar zu Euro Kurs aktuell umrechnen", category: "Geldanlage", imageAlt: "Dollar to Euro conversion" },
  { title: "Renteneintrittsalter nach Geburtsjahr berechnen", category: "Rente & Pension", imageAlt: "Retirement age by year of birth" },
  { title: "kW in PS Umrechnung: Formel & Tabelle", category: "Technik", imageAlt: "kW in hp" },
  { title: "BMI Berechnen f\u00FCr Frauen: Idealgewicht Tabelle", category: "Gesundheit", imageAlt: "BMI calculation for women" },
  { title: "Fernseher Gr\u00F6lentabelle: 65 Zoll in cm", category: "Technik", imageAlt: "TV size 65 inches in cm" },
  { title: "Steuertabelle f\u00FCr Rentner: Abgaben & Freibetrag", category: "Steuern", imageAlt: "Tax table for pensioners" },
  { title: "Knoten in km/h umrechnen: Einfache Formel", category: "Umrechnung", imageAlt: "Knots in km/h" },
  { title: "lbs in kg umrechnen | Pfund in Kilogramm", category: "Umrechnung", imageAlt: "lbs in kg" }
];

export const INFOCENTER_HIGHLIGHTS: GuidelineItem[] = [
  { title: "Feiertage im Juni 2026 in Deutschland", category: "Kalender", imageAlt: "All public holidays in June" },
  { title: "Wann ist Pfingsten 2026? Termine & Br\u00FCckentage", category: "Kalender", imageAlt: "Pentecost 2026" },
  { title: "Sommeranfang 2026: Datum, Uhrzeit & Sommersonnenwende", category: "Natur & Zeit", imageAlt: "Summer 2026" },
  { title: "Schulferien in Baden-W\u00FCrttemberg 2026", category: "Ferien", imageAlt: "School holidays in Baden-W\u00FCrttemberg" },
  { title: "Schulferien in Bayern 2026", category: "Ferien", imageAlt: "Holidays in Bavaria" },
  { title: "Schulferien in Hessen 2025 / 2026", category: "Ferien", imageAlt: "School holidays in Hesse" },
  { title: "Ferientermine Nordrhein-Westfalen (NRW)", category: "Ferien", imageAlt: "North Rhine-Westphalia school holidays" },
  { title: "3.000 Euro Brutto in Netto umrechnen", category: "Lohn & Gehalt", imageAlt: "3,000 euros gross converted to net" },
  { title: "4.000 Euro Brutto in Netto umrechnen", category: "Lohn & Gehalt", imageAlt: "4,000 euros gross converted to net" },
  { title: "Konvertierung von Kilogramm zu Gramm", category: "Umrechnung", imageAlt: "Conversion from kilograms to grams" },
  { title: "Kalender 2026 mit allen Feiertagen", category: "Kalender", imageAlt: "Calendar 2026" },
  { title: "NRW Kalender 2026 zum Ausdrucken", category: "Kalender", imageAlt: "NRW Calendar 2026" },
  { title: "Kalenderwochen 2026 im \u00DCberblick", category: "Kalender", imageAlt: "Calendar weeks 2026 - CW 2026" },
  { title: "Kalenderwoche KW 25, 2026 Termine", category: "Kalender", imageAlt: "Week 25, 2026" },
  { title: "Kalenderwoche KW 26, 2026 Termine", category: "Kalender", imageAlt: "Week 26, 2026" },
  { title: "Kalenderwoche KW 27, 2026 Termine", category: "Kalender", imageAlt: "Week 27, 2026" },
  { title: "Meilen in Meter umrechnen: Formeln", category: "Umrechnung", imageAlt: "Conversion from miles to meters" },
  { title: "Sonnenaufgang & Sonnenuntergang heute in Berlin", category: "Zeit", imageAlt: "Sunrise and sunset in Berlin" },
  { title: "Sonnenaufgang heute in K\u00F6ln & D\u00FCsseldorf", category: "Zeit", imageAlt: "Sunrise and sunset Cologne" },
  { title: "Sonnenaufgang heute in M\u00FCnchen & Bayern", category: "Zeit", imageAlt: "Sunrise and sunset Munich" }
];

export const STATISTIK_HIGHLIGHTS: GuidelineItem[] = [
  { title: "Entwicklung der Abfindungen in Deutschland", category: "Arbeitsrecht", imageAlt: "Trends in severance pay in Germany" },
  { title: "Statistiken zur Kirchensteuer & Kirchenaustritten", category: "Steuern", imageAlt: "Trends regarding church tax in Germany" },
  { title: "Aktuelle Gehaltsdaten & Durchschnittsl\u00F6hne", category: "Lohn & Gehalt", imageAlt: "Salary figures for Germany" },
  { title: "Wohngeld-Statistiken und Antragszahlen", category: "Soziales & Wohnen", imageAlt: "Figures on housing benefit in Germany" }
];

export const TOP_CALCULATORS = [
  { name: "Feiertage 2026", path: "#/feiertage-2026" },
  { name: "Feiertage 2027", path: "#/feiertage-2027" },
  { name: "Feiertage NRW 2026", path: "#/feiertage-nrw-2026" },
  { name: "Brückentage-Planer", path: "#/brueckentage-planer" },
  { name: "Abfindungsrechner", path: "#/abfindungsrechner" },
  { name: "Arbeitslosengeld-Rechner", path: "#/arbeitslosengeld-rechner" },
  { name: "Brutto-Netto-Rechner", path: "#/brutto-netto" },
  { name: "Bankverbindung prüfen", path: "#/bankverbindung-pruefen" },
  { name: "Bankleitzahlensuche", path: "#/blz-suche" },
  { name: "ETF-Sparplanrechner", path: "#/etf-sparplanrechner" },
  { name: "Einkommensteuer-Rechner", path: "#/einkommensteuer" },
  { name: "Lohnsteuer-Rechner", path: "#/lohnsteuerrechner" },
  { name: "Nettopreis-Rechner", path: "#/nettopreis-rechner" },
  { name: "Steuerrechner (Steuer berechnen)", path: "#/steuer-berechnen" },
  { name: "Altersrechner", path: "#/altersrechner" },
  { name: "Arbeitstage-Rechner", path: "#/arbeitstage-rechner" },
  { name: "Rentenbezugsrechner", path: "#/rentenbezugsrechner" },
  { name: "Annuit\u00E4tenrechner", path: "#/kreditrechner" },
  { name: "BMI-Rechner", path: "#/bmi-rechner" },
  { name: "Elterngeldrechner", path: "#/elterngeldrechner" },
  { name: "Erbschaftsteuer-Rechner", path: "#/erbschaftsteuer-rechner" },
  { name: "Gesetzliche Erbfolge Rechner", path: "/erbfolge-rechner" },
  { name: "Firmenwagenrechner", path: "#/firmenwagenrechner" },
  { name: "Kalenderwochen", path: "#/kalenderwochen" },
  { name: "Kfz-Steuer-Rechner", path: "#/kfz-steuer-rechner" },
  { name: "Ratenkredit-Rechner", path: "#/ratenkredit" },
  { name: "Kurzarbeitergeld-Rechner", path: "#/kurzarbeitergeld-rechner" },
  { name: "Kirchensteuerrechner", path: "#/kirchensteuerrechner" },
  { name: "Umsatzsteuerrechner", path: "#/umsatzsteuerrechner" },
  { name: "Promillerechner", path: "#/promillerechner" },
  { name: "Prozentrechner", path: "#/prozentrechner" },
  { name: "Rentensteuer-Rechner", path: "#/rentensteuer" },
  { name: "Sonnenaufgang & Sonnenuntergang", path: "#/sonnenaufgang-untergang" },
  { name: "Stundenlohnrechner", path: "#/stundenlohnrechner" },
  { name: "Mindestlohnrechner", path: "#/mindestlohnrechner" },
  { name: "Online-Rechner", path: "#/online-rechner" },
  { name: "Kindesunterhalt D\u00FCsseldorfer Tabelle", path: "#/kindesunterhalt" },
  { name: "Wohngeldrechner", path: "#/wohngeldrechner" },
  { name: "Restwert-Rechner (Auto-Wertverlust)", path: "/restwert-rechner" },
  { name: "L\u00E4ngenumrechner", path: "#/laengenumrechner" },
  { name: "W\u00E4rmepumpen-Rechner", path: "#/waermepumpe" },
  { name: "Zinseszinsrechner", path: "#/sparrechner" },
  { name: "Overtime-Rechner", path: "#/overtime-rechner" },
  { name: "Arbeitszeitrechner", path: "#/arbeitszeitrechner" }
];
